/* eslint-disable max-lines */
import { partners, operations } from 'api';
import {
  FETCH_PARTNERS,
  PARTNER_BY_ID,
  FETCH_PARTNERS_FOR_SELECT,
  FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_B2C,
  FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_B2B,
  FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL_B2C,
  FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL_B2B,
  FETCH_EXPIRATIONS_BY_PARTNER_ID_SUMMARY,
  FETCH_EXPIRATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL,
  OPERATION_BY_ID_B2C,
  OPERATION_BY_ID_B2B,
  UPDATE_OPERATIONS_B2C,
  UPDATE_OPERATIONS_B2B,
  UPDATE_EXPIRATIONS,
  UPDATE_OPERATION_SELECT,
  DELETE_OPERATION_BY_ID,
  SET_PARTNERS_PROPERTY,
  CREATE_NEW_PARTNER,
  FETCH_PARTNERS_THEMES,
  FETCH_PARTNER_BY_ID
} from 'store/actions/partner';
import { userPartnerId } from 'helpers/user';
import { paginationData } from 'helpers/store';

export default {
  [SET_PARTNERS_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_PARTNERS_PROPERTY, {
      field,
      value
    }),

  [FETCH_PARTNERS]: ({ state, commit }) =>
    new Promise((resolve, reject) => {
      if (state.partners.length > 0) return resolve();
      partners.fetch().then(
        resp => {
          const data = resp.data;
          commit(FETCH_PARTNERS, data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [PARTNER_BY_ID]: ({ commit }, { partnerId }) =>
    new Promise((resolve, reject) => {
      partners.partnerById(partnerId).then(
        resp => {
          commit(PARTNER_BY_ID, resp.data);
          resolve(resp.data);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [FETCH_PARTNER_BY_ID]: ({ commit }, { partnerId, fields }) =>
    new Promise((resolve, reject) => {
      partners.fetchPartnerById({ partnerId, fields }).then(
        resp => {
          commit(FETCH_PARTNER_BY_ID, resp.data);
          resolve(resp.data);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [FETCH_PARTNERS_FOR_SELECT]: ({ commit }) =>
    new Promise((resolve, reject) => {
      partners
        .fetch(`partnerId,partnerName,partnerLogoURL,maxTopCampaigns,configuration.flows`)
        .then(
          resp => {
            const data = resp.data || [];
            commit(FETCH_PARTNERS_FOR_SELECT, data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [FETCH_PARTNERS_THEMES]: ({ commit }) =>
    new Promise(resolve => {
      commit('FETCH_PARTNERS_THEMES');
      resolve();
    }),

  [FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_B2C]: ({ commit }, { partnerId, pagination, filters }) =>
    new Promise(async (resolve, reject) => {
      const id = partnerId || (await userPartnerId());
      const limit = pagination.perPage;
      const offset = limit * (pagination.currentPage - 1);
      partners
        .operationsByPartnerIdSummaryB2C({
          partnerId: id,
          pagination: {
            limit,
            offset,
            sort: pagination.sortBy,
            sortType: pagination.sortDesc ? 'DESC' : 'ASC'
          },
          filters
        })
        .then(
          resp => {
            const data = resp.data || [];
            commit(UPDATE_OPERATIONS_B2C, data);
            resolve(paginationData(resp).total);
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_B2B]: ({ commit }, { partnerId, pagination, filters }) =>
    new Promise(async (resolve, reject) => {
      const id = partnerId || (await userPartnerId());
      const limit = pagination.perPage;
      const offset = limit * (pagination.currentPage - 1);
      partners
        .operationsByPartnerIdSummaryB2B({
          partnerId: id,
          pagination: {
            limit,
            offset,
            sort: pagination.sortBy,
            sortType: pagination.sortDesc ? 'DESC' : 'ASC'
          },
          filters
        })
        .then(
          resp => {
            const data = resp.data || [];
            commit(UPDATE_OPERATIONS_B2B, data);
            resolve(paginationData(resp).total);
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [FETCH_EXPIRATIONS_BY_PARTNER_ID_SUMMARY]: ({ commit }, { partnerId, pagination, filters }) =>
    new Promise(async (resolve, reject) => {
      const id = partnerId || (await userPartnerId());
      const limit = pagination.perPage;
      const offset = limit * (pagination.currentPage - 1);
      partners
        .expirationsByPartnerIdSummary({
          partnerId: id,
          pagination: {
            limit,
            offset,
            sort: pagination.sortBy,
            sortType: pagination.sortDesc ? 'DESC' : 'ASC'
          },
          filters
        })
        .then(
          resp => {
            const data = resp.data || [];
            commit(UPDATE_EXPIRATIONS, data);
            resolve(data.length);
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL_B2C]: (
    { commit },
    { partnerId, pagination, filters }
  ) =>
    new Promise(async (resolve, reject) => {
      const id = partnerId || (await userPartnerId());
      const limit = pagination.perPage;
      const offset = limit * (pagination.currentPage - 1);
      partners
        .operationsByPartnerIdSummaryB2C({
          partnerId: id,
          pagination: {
            limit: 2000,
            offset,
            sort: pagination.sortBy,
            sortType: pagination.sortDesc ? 'DESC' : 'ASC'
          },
          filters
        })
        .then(
          resp => {
            resolve(resp.data || []);
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [FETCH_OPERATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL_B2B]: (
    { commit },
    { partnerId, pagination, filters }
  ) =>
    new Promise(async (resolve, reject) => {
      const id = partnerId || (await userPartnerId());
      const limit = pagination.perPage;
      const offset = limit * (pagination.currentPage - 1);
      partners
        .operationsByPartnerIdSummaryB2B({
          partnerId: id,
          pagination: {
            limit: 2000,
            offset,
            sort: pagination.sortBy,
            sortType: pagination.sortDesc ? 'DESC' : 'ASC'
          },
          filters
        })
        .then(
          resp => {
            resolve(resp.data || []);
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [FETCH_EXPIRATIONS_BY_PARTNER_ID_SUMMARY_EXPORT_EXCEL]: (
    { commit },
    { partnerId, pagination, filters }
  ) =>
    new Promise(async (resolve, reject) => {
      const id = partnerId || (await userPartnerId());
      const limit = pagination.perPage;
      const offset = limit * (pagination.currentPage - 1);
      partners
        .expirationsByPartnerIdSummary({
          partnerId: id,
          pagination: {
            limit: limit * 4,
            offset,
            sort: pagination.sortBy,
            sortType: pagination.sortDesc ? 'DESC' : 'ASC'
          },
          filters
        })

        .then(
          resp => {
            resolve(resp.data || []);
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
    }),

  [OPERATION_BY_ID_B2C]: ({ commit }, operationId) =>
    new Promise((resolve, reject) => {
      operations.operationByIdB2C(operationId).then(
        resp => {
          const data = resp.data;
          commit(UPDATE_OPERATION_SELECT, data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [OPERATION_BY_ID_B2B]: ({ commit }, operationId) =>
    new Promise((resolve, reject) => {
      operations.operationByIdB2B(operationId).then(
        resp => {
          const data = resp.data;
          commit(UPDATE_OPERATION_SELECT, data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [DELETE_OPERATION_BY_ID]: ({ commit }, operationId) =>
    new Promise((resolve, reject) => {
      operations.deleteOperation(operationId).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [CREATE_NEW_PARTNER]: ({ commit }, param) =>
    new Promise((resolve, reject) => {
      const partner = JSON.parse(JSON.stringify(param));
      partner.idConfigLleidaClickSign = Number(partner.idConfigLleidaClickSign);
      partners.createNewPartner(partner).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    })
};
